import BootstrapOffcanvas from "react-bootstrap/Offcanvas";
import classNames from "classnames";
import OffcanvasHeader from "./OffcanvasHeader";

function Offcanvas({
  show = false,
  onHide = () => {},
  onGoBack = () => {},
  goBackButton = false,
  closeButton = true,
  title = "",
  Footer = null,
  children,
  size = "",
  bodyRef = null,
  ...props
}) {
  return (
    <BootstrapOffcanvas
      show={show}
      onHide={onHide}
      className={classNames(size === "lg" && "size-lg")}
      {...props}
    >
      <div className="offcanvas-content-custom">
        <OffcanvasHeader
          title={title}
          closeButton={closeButton}
          onHide={onHide}
          onGoBack={onGoBack}
          goBackButton={goBackButton}
        />

        <BootstrapOffcanvas.Body ref={bodyRef}>{children}</BootstrapOffcanvas.Body>

        <div className="offcanvas-footer-custom">{Footer}</div>
      </div>
    </BootstrapOffcanvas>
  );
}

export default Offcanvas;
